<template>
  <v-container no-gutter>
    <v-row>
      <v-col cols="auto">
        <div>ネッツトヨタ福岡</div>
        <div>{{profile.name}}</div>
      </v-col>
      <v-col cols="auto">
        <div>{{profile.pref}}{{profile.address}}</div>
        <div>TEL: {{profile.phone}}</div>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <span>ネッツトヨタ福岡株式会社</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters('shop', [
      'profile'
    ])
  }
}
</script>
